import router from '@/routes';

export const reportTypeFromRoute  = ()=>{
  switch(router.currentRoute.name) {
    case 'app.conversions':
      return 'conversions';
    case 'app.postbacks':
      return 'postbacks';
    case 'app.errors':
      return 'errors';
    case 'app.live-clicks':
      return 'live-clicks';
    case 'app.live-visits':
      return 'live-visits';

    default:
      return router.currentRoute.params.type;
  }
}

export const reportTypeFromMetricName  = (metric:string)=>{
  switch(metric) {
    case 'errors':
      return 'app.errors';
    case 'conversions':
      return 'app.conversions';
    case 'postbacks':
      return 'app.postbacks';
    case 'live-clicks':
      return 'app.live-clicks';
    case 'live-visits':
      return 'app.live-visits';
    default:
      return 'app.report';
  }
}